import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "../components/loadingScreen/LoadingScreen";
import { UserDetailsContext } from "../context/userDetails";
import { JWTToken, MUSE_STATUS, PARAMS_PROP, SESSION_STORAGE_KEY } from "../vars";
import { handleGetUserDetails, hasNullValue, removeLocalStorage, removeSessionStorage, setSessionStorage } from "../utils/util";
import useIsCustom from "../customHook/useIsCustom";
import useOtp from "../customHook/useOtp";

function UserAttributesWrapper({ children }) {
	const {  shopDomain, setGender, setUserInfo, setName, scanType,setEmail } = useContext(UserDetailsContext);
	const [loading, setLoading] = useState(true);
	const navigate = useNavigate();
	const isCustom = useIsCustom();
	const { validateUserOnAppLoad } = useOtp();

	const syncUserData = useCallback(async (data) => {
		if (data?.gender) {
			setGender(data?.gender);
			setSessionStorage(SESSION_STORAGE_KEY.GENDER, data?.gender);
		}
		if (data?.height) {
			setUserInfo((prev) => ({ ...prev, height: { cm: +data.height } }));
			setSessionStorage(SESSION_STORAGE_KEY.HEIGHT, data?.height);
		}
	}, []);
	const handleExtractAttributes = useCallback(async () => {
		try {
			if (!hasNullValue(PARAMS_PROP.TOKEN)) {
			removeLocalStorage(JWTToken);
		}
			removeSessionStorage(SESSION_STORAGE_KEY.FACE_SCAN_NOT_DONE);
			removeSessionStorage(SESSION_STORAGE_KEY.IS_VERIFIED);
			console.log(!hasNullValue(PARAMS_PROP.SILENT_AUTH),"hasNullValue(PARAMS_PROP.SILENT_AUTH)");
			
			if (!hasNullValue(PARAMS_PROP.SILENT_AUTH)) {
				return
			}
			const res = await validateUserOnAppLoad();
			console.log(res,"res");

			if (res && res?.needsLogin) {
				return;
			}
			setSessionStorage(SESSION_STORAGE_KEY.IS_VERIFIED, true);
			let details = await handleGetUserDetails();
			details = details?.data;
			if (details?.email) {
				setEmail(details?.email)
				setSessionStorage(SESSION_STORAGE_KEY.EMAIL, details?.email);
			}
			if (details?.username) {
				setName(details?.username);
				setSessionStorage(SESSION_STORAGE_KEY.NAME, details?.username);
			}
			syncUserData(details?.attributes);
			// if (details?.attributes?.verified) {
			if (!details?.isMeasured) {
				// navigate(SETUP_FLOW);
			} else if ((!details?.isMuseGenerated || details?.isMuseGenerated === "failed") && !isCustom) {
				// navigate(FACE_SCAN)
				setSessionStorage(SESSION_STORAGE_KEY.FACE_SCAN_NOT_DONE, true);
			} else if (!isCustom) {
				navigate(MUSE_STATUS);
			}
			// }
		} catch (error) {
			console.log(error, "while extracting");
			// removeLocalStorage(JWTToken);
		} finally {
			setTimeout(() => setLoading(false), 1000);
		}
	}, [loading,shopDomain, isCustom, validateUserOnAppLoad]);

	useEffect(() => {
		if (shopDomain && scanType) {
			handleExtractAttributes();
		}
	}, [shopDomain]);

	return loading ? <LoadingScreen loaderType="black" className="h-full w-full desktop-wrapper fitViewScreen flex alignCenter justifyCenter" /> : children;
}

export default UserAttributesWrapper;
